module.exports = __webpack_public_path__ + "media/images/main_logo_privacy-97bfbb58.png";